module.exports = __webpack_public_path__ + "static/media/mitrphol.37742757.png";